import {httpPost} from "../http/axios";

export function starList(data) {
    return httpPost('/api/student_study/my_subscriptions', data, '我的订阅课程列表')
}
export function grammarCheckTry(data) {
    return httpPost('/api/grammar_curriculum/check_try', data, '获取课程剩余次数')
}
export function grammarCenter(data) {
    return httpPost('/api/grammar/index', data, '学习中心')
}

//强制复习相关
export function reviewNum(data) {
    return httpPost('/api/grammar_wordbook/review_list', data, '需要强制复习的单词个数')
}

export function getGrammar(data) {
    return httpPost('/api/grammar_wordbook/get_review_grammar', data, '获取语法')
}

export function clickFace(data) {
    return httpPost('/api/grammar_wordbook/save_study', data, '强制复习-笑脸/哭脸')
}

export function spellOrder(data) {
    return httpPost('/api/grammar_wordbook/review_spell', data, '请求拼写-原序/逆序')
}

export function getSpell(data) {
    return httpPost('/api/grammar_wordbook/get_review_spell', data, '拼写-获取语法')
}

export function pushSpell(data) {
    return httpPost('/api/grammar_wordbook/save_spell', data, '提交拼写')
}

export function saveQuit(data) {
    return httpPost('/api/grammar_wordbook/save_quit', data, '提交拼写')
}

// 单词中途退出额外请求
export function emptyOnceStudyNum(data) {
    return httpPost('/api/grammar/empty_once_study_num', data, '退出')
}

export function grammarCourseList(data) {
    return httpPost('/api/grammar_curriculum/choice_curriculum', data, '选课中心页面')
}

export function grammarSaveCourse(data) {
    return httpPost('/api/grammar_curriculum/save_choice', data, '选课中心保存')
}

export function getUnitList(data) {
    return httpPost('/api/grammar/grammar_unit', data, '获取单元列表')
}

export function selectUnit(data) {
    return httpPost('/api/grammar/choice_unit', data, '选择语法学习单元')
}

export function getUnitGrammar(data) {
    return httpPost('/api/grammar/get_grammar', data, '获取语法')
}

export function yfClickFace(data) {
    return httpPost('/api/grammar/save_study', data, '笑脸&&苦脸')
}

export function getExample(data) {
    return httpPost('/api/grammar/get_example', data, '语法学习-逆向记忆')
}

export function yfSpellOrder(data) {
    return httpPost('/api/grammar/grammar_spell', data, '语法-请求拼写-原序/逆序')
}

export function yfGetSpell(data) {
    return httpPost('/api/grammar/get_spell', data, '语法学习-获取拼写语法')
}

export function yfPushSpell(data) {
    return httpPost('/api/grammar/spell_study', data, '语法学习-获取拼写语法')
}


export function yfSaveQuit(data) {
    return httpPost('/api/grammar/save_quit', data, '语法学习-保存退出')
}

export function yfBreakQuit(data) {
    return httpPost('/api/grammar/break_quit', data, '语法学习-中途退出')
}

export function unitMemory(data) {
    return httpPost('/api/grammar/unit_memory', data, '单元整体回忆')
}

export function recallQuit(data) {
    return httpPost('/api/grammar/quit_unit_memory', data, '单元整体回忆-退出')
}

export function unitTest(data) {
    return httpPost('/api/grammar_paper/get_unit_paper', data, '单元测试')
}

export function pushPaper(data) {
    return httpPost('/api/grammar_paper/save_unit_paper', data, '提交单元测试')
}

export function selfTest(data) {
    return httpPost('/api/grammar_paper/get_initiative_paper', data, '自测试卷')
}

export function selfPushPaper(data) {
    return httpPost('/api/grammar_paper/save_initiative_paper', data, '自测试卷结果')
}

export function comparisonTest(data) {
    return httpPost('/api/grammar_paper/get_composer_paper', data, '对比测试试卷')
}

export function PushComparisonTest(data) {
    return httpPost('/api/grammar_paper/save_composer_paper', data, '对比测试交卷')
}

export function searchComparisonTestGrade(data) {
    return httpPost('/api/grammar_paper/get_composer_result', data, '对比测试查询测试成绩')
}


export function unitDictation(data) {
    return httpPost('/api/grammar_paper/get_dictate_paper', data, '单元听写试卷')
}

export function pushUnitDictation(data) {
    return httpPost('/api/grammar_paper/save_dictate_paper', data, '单元听写交卷')
}

export function bookTest(data) {
    return httpPost('/api/grammar_paper/get_book_paper', data, '本书测试')
}

export function pushBookTest(data) {
    return httpPost('/api/grammar_paper/save_book_paper', data, '提交本书测试')
}
export function checkBook(data) {
    return httpPost('/api/grammar_paper/check_book', data, '本书测试是否学习完本单元')
}

// 语法错题本
export function studyErrorBook(data) {
    return httpPost('/api/grammar_errorbook/study_errorbook', data, '判断是否有需要学习的语法')
}

export function getStudyData(data) {
    return httpPost('/api/grammar_errorbook/get_study_data', data, '获取学习语法')
}

export function saveStudy(data) {
    return httpPost('/api/grammar_errorbook/save_study', data, '苦脸笑脸')
}

export function getSpellData(data) {
    return httpPost('/api/grammar_errorbook/get_spell_data', data, '获取拼写语法')
}

export function spellOrderError(data) {
    return httpPost('/api/grammar_errorbook/spell_order', data, '原序逆序')
}

export function saveSpellError(data) {
    return httpPost('/api/grammar_errorbook/save_spell', data, '保存拼写')
}

export function breakQuit(data) {
    return httpPost('/api/grammar_errorbook/break_quit', data, '获取退出数据')
}

export function intelligentReview(data) {
    return httpPost('/api/grammar_wordbook/intelligent_review', data, '智能复习首页')
}

export function getIntelligentGrammar(data) {
    return httpPost('/api/grammar_wordbook/get_intelligent_grammar', data, '智能复习-获取语法')
}

export function saveIntelligentStudy(data) {
    return httpPost('/api/grammar_wordbook/save_intelligent_study', data, '智能复习-笑脸/哭脸')
}

export function intelligentReviewSpell(data) {
    return httpPost('/api/grammar_wordbook/intelligent_review_spell', data, '智能复习-原序/逆序')
}

export function getIntelligentSpell(data) {
    return httpPost('/api/grammar_wordbook/get_intelligent_spell', data, '智能复习-获取拼写语法')
}

export function saveIntelligentSpell(data) {
    return httpPost('/api/grammar_wordbook/save_intelligent_spell', data, '智能复习-提交拼写')
}

export function AIbreakQuit(data) {
    return httpPost('/api/grammar_wordbook/break_quit', data, '智能复习-中途退出')
}

export function saveIntelligentQuit(data) {
    return httpPost('/api/grammar_wordbook/save_intelligent_quit', data, '智能复习-保存退出')
}

export function intelligentDictation(data) {
    return httpPost('/api/grammar_errorbook/intelligent_dictation', data, '智能听写-首页')
}

export function AIgetSpell(data) {
    return httpPost('/api/grammar_errorbook/get_spell', data, '智能听写-获取拼写语法')
}

export function AIspellStudy(data) {
    return httpPost('/api/grammar_errorbook/spell_study', data, '智能听写-提交拼写')
}

export function ZNbreakQuit(data) {
    return httpPost('/api/grammar_wordbook/break_quit', data, '智能听写-中途提出')
}

export function preciseIntelligentReview(data) {
    return httpPost('/api/grammar_wordbook/intelligent_review', data, '精准复习-首页')
}

export function preciseGetIntelligentGrammar(data) {
    return httpPost('/api/grammar_wordbook/get_intelligent_grammar', data, '精准复习-获取语法')
}

export function preciseSaveIntelligentStudy(data) {
    return httpPost('/api/grammar_wordbook/save_intelligent_study', data, '精准复习-笑脸/哭脸')
}

export function preciseIntelligentReviewSpell(data) {
    return httpPost('/api/grammar_wordbook/intelligent_review_spell', data, '精准复习-原序/逆序')
}

export function preciseGetIntelligentSpell(data) {
    return httpPost('/api/grammar_wordbook/get_intelligent_spell', data, '精准复习-获取拼写语法')
}

export function preciseSaveIntelligentSpell(data) {
    return httpPost('/api/grammar_wordbook/save_intelligent_spell', data, '精准复习-提交拼写')
}

export function preciseSaveIntelligentQuit(data) {
    return httpPost('/api/grammar_wordbook/save_intelligent_quit', data, '精准复习-保存退出')
}

export function preciseBreakQuit(data) {
    return httpPost('/api/grammar_wordbook/break_quit', data, '精准复习-中途退出')
}

export function getEdition(data) {
    return httpPost('/api/grammar_exam/get_edition', data, '语法量测试-获取版本')
}

export function getSubject(data) {
    return httpPost('/api/grammar_exam/get_subject', data, '语法量测试-获取题目')
}

export function saveTest(data) {
    return httpPost('/api/grammar_exam/save_test', data, '语法量测试-交卷')
}

export function myBook(data) {
    return httpPost('/api/grammar_wordbook/my_book', data, '生词本')
}

export function saveStudentSetup(data) {
    return httpPost('/api/student_center/save_grammar_student_setup', data, '语法个人设置-保存')
}



